// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: 'Assistant', sans-serif;
}

.app-container {
    margin: 0 auto;
    position: relative;
    border-color: #848484;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    min-height: 100%;
}


.login-footer {
    padding: 20px;
    bottom: 0;
    z-index: 1;
}

.footer-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}


.exit-button {
    background: #06A9C9;
    border-radius: 10px;
    align-items: center;
    height: 35px;
    width: 110px;
    font-weight: 400;
    font-size: 18px;
    border: none;
    cursor: pointer;
    color: #FFFFFF;
    float: left;
    margin-top: 10px;
    margin-bottom: 20px;
    white-space: nowrap;
    text-align: center;
    padding-bottom: 5px;
}

.accessibility-bottom {
    background: none;
    border: none;
}


@media only screen and (min-width: 450px) {
    .login-footer {
        display: inline-block;
        margin-block-start: 50px;
        margin-inline: 20px;
    }

    .exit-button {
        background: #A9D3DC;
        height: 40px;
        font-size: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;;AAGA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI;QACI,qBAAqB;QACrB,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":["* {\n    font-family: 'Assistant', sans-serif;\n}\n\n.app-container {\n    margin: 0 auto;\n    position: relative;\n    border-color: #848484;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    min-height: 100%;\n}\n\n\n.login-footer {\n    padding: 20px;\n    bottom: 0;\n    z-index: 1;\n}\n\n.footer-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n}\n\n\n.exit-button {\n    background: #06A9C9;\n    border-radius: 10px;\n    align-items: center;\n    height: 35px;\n    width: 110px;\n    font-weight: 400;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    color: #FFFFFF;\n    float: left;\n    margin-top: 10px;\n    margin-bottom: 20px;\n    white-space: nowrap;\n    text-align: center;\n    padding-bottom: 5px;\n}\n\n.accessibility-bottom {\n    background: none;\n    border: none;\n}\n\n\n@media only screen and (min-width: 450px) {\n    .login-footer {\n        display: inline-block;\n        margin-block-start: 50px;\n        margin-inline: 20px;\n    }\n\n    .exit-button {\n        background: #A9D3DC;\n        height: 40px;\n        font-size: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
